import { render, staticRenderFns } from "./AboutSidebar.vue?vue&type=template&id=c86d632e&"
import script from "./AboutSidebar.vue?vue&type=script&lang=js&"
export * from "./AboutSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AboutSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports